import { StudiesResponse, StudySurveyDefinitionResponse, StudySurveyResponse,StudyDefFormat, StudyStatsResponse } from "./types/studies";

import { createApi, FetchArgs } from '@reduxjs/toolkit/query/react'
import { baseQuery } from "./default";

interface StudyDefinitionQueryArgs {
  study: string;
  survey: string;
  format: StudyDefFormat
}

// Define a service using a base URL and expected endpoints
export const StudiesApi = createApi({
  reducerPath:'apiStudy',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getStudies: builder.query<StudiesResponse, void>({
      query: () => `api/list-studies`,
    }),
    getStudyStats: builder.query<StudyStatsResponse, string>({
      query: (study_key) => `api/study/${study_key}/stats`,
    }),
    getStudySurveys: builder.query<StudySurveyResponse, string>({
      query: (study_key) => `/api/study/${study_key}/list-surveys`
    }),
    getStudySurvey: builder.query<StudySurveyDefinitionResponse, StudyDefinitionQueryArgs>({
      query: (args) => ({
        url: `/api/study/${args.study}/survey/${args.survey}.${args.format}`
      })
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetStudiesQuery, useGetStudySurveysQuery, useGetStudySurveyQuery, useGetStudyStatsQuery } = StudiesApi;
